import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Caring Haven</h3>
            <p>Providing compassionate personal care in Regina, Saskatchewan</p>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>📍 Regina, Saskatchewan</p>
            <p>📞 (306) 555-0123</p>
            <p>✉️ info@caringhaven.ca</p>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li>Personal Care</li>
              <li>24/7 Support</li>
              <li>Meal Services</li>
              <li>Recreation Activities</li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Caring Haven. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;